import style from './_style.scss';

import cookieBar from './js/cookieBar';
import PreventDoubleSubmit from '../../../../_shared/js/utils/PreventDoubleSubmit';
import forms from './js/forms';
import Modal from 'bootstrap/js/dist/modal.js';
import Collapse from 'bootstrap/js/dist/collapse.js';
import navbar from './js/navbar';
import addPremiumForm from './js/add-premium-form';
// Nastavení Modal na window
window.Modal = Modal;
// Nastavení Collapse na window
window.Collapse = Collapse;
import { executeOnDocumentReady } from '../../utils';
import copyText from './js/copyText';

executeOnDocumentReady(() => {
	cookieBar();
	PreventDoubleSubmit();
	forms();
	navbar();
	copyText();
	addPremiumForm();
});
